import { render } from "./tradeConvert.vue?vue&type=template&id=decdd49c&scoped=true"
import script from "./tradeConvert.vue?vue&type=script&lang=js"
export * from "./tradeConvert.vue?vue&type=script&lang=js"

import "./tradeConvert.vue?vue&type=style&index=0&id=decdd49c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-decdd49c"]])

export default __exports__